import {
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { DynaDocsModelRepository } from '@/store/dyna-docs-model-state/dyna-docs-model-state.repository';
import {DynaStatus} from '@/types';

interface Props {
  store: DynaDocsModelRepository;
  rowActions?: DataTableRowActions;
  createAction: () => void;
  enableServerActions?: boolean;
  serverQuery?: any;
}

export const getDynaDocsModelDataTableStructure = ({
  store,
  rowActions,
  createAction,
  enableServerActions,
  serverQuery,
}: Props): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn = {
    label: 'settings.dynaDocsModels.table.id',
    accessorKey: 'dynaDocsModelId',
    variant: DataTableColumnVariant.TEXT,
  };
  const descriptionColumn: DynamicDataTableColumn = {
    label: 'settings.dynaDocsModels.table.description',
    accessorKey: 'description',
    variant: DataTableColumnVariant.TEXT,
  };

  const statusColumn: DynamicDataTableColumn = {
    label: 'settings.dynaDocsModels.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: DynaStatus) => {
      return { value: value == DynaStatus.ACTIF ? 'dynamicDocument.form.active' : 'dynamicDocument.form.inActive' };
    },
    props: {
      getSeverity: (value: DynaStatus) => {
        return value == DynaStatus.ACTIF ? 'success' : 'danger';
      },
    },  };

  return {
    singular: 'settings.dynaDocsModels.table.singular',
    plural: 'settings.dynaDocsModels.table.plural',
    columns: [idColumn, descriptionColumn,statusColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.set('serverState', { description: row.description });
      store.set('dto', { description: row.description });
      store.set('dto', { status: row.status });

    },
    createAction,
    rowActions,
    enableServerActions,
    serverQuery,
  };
};
